import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

export namespace ApiTaCt140 {
  export namespace Get {
    export interface Request {
      query: {
        pieceId: string
        unitId: string
      }
    }
    export interface SheetContent {
      answerSheetContentId: string // 添削答案コンテンツID
      answerSheetContentName: string // 添削答案コンテンツ名
      answerSheetContentUrl: string // 添削答案コンテンツURL
      contentType: number // 添削答案コンテンツタイプ: 1:ヘッダーコンテンツ 2:問題用紙コンテンツ 3:解答用紙コンテンツ 4:音声再生コンテンツ
      answerViewPhaseId: number // 添削答案閲覧状態: 0:区分なし 1:解答時 2:提出時
      layoutPatternId: number // レイアウトパターン: 1:縦型配置 2:横型配置 3:集約配置
      positionNum: number // 配置番号: 右上から右下に向けて1,2,3...と採番します。 0:問題用紙エリア n:解答用紙エリア -1:音声再生エリア
    }
    export interface Response {
      answerId: string
      contents: SheetContent[]
    }
  }

  export const path: string = '/ta/fullDigitalSheet'

  export class Api extends ApiBase implements Gettable<ApiTaCt140.Get.Request, ApiTaCt140.Get.Response, ResponseError> {
    public get<R>(
      params: ApiTaCt140.Get.Request,
      successHandler: ApiResponseHandler<ApiTaCt140.Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      const validationSample: ApiTaCt140.Get.Response = {
        answerId: '',
        contents: [
          {
            answerSheetContentId: '',
            answerSheetContentName: '',
            answerSheetContentUrl: '',
            contentType: 0,
            answerViewPhaseId: 0,
            layoutPatternId: 0,
            positionNum: 0,
          },
        ],
      }

      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      return this.callbackWrapper<ApiTaCt140.Get.Response, ResponseError, R>(
        api.get<ApiTaCt140.Get.Response>(ApiTaCt140.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
